import InfoBar from 'components/InfoBar';
import type { FieldRendererProps } from '../types';

export function InfoBarField({ field }: FieldRendererProps) {
  return <InfoBar icon={field.icon} label={field.label} value={field.value} />;
}
